
import axios from 'axios';
import { API_URL } from '@/config/api.config'


const categoryAPI = {
    /**
     * 获取分类列表
     */
    getCategoryList: async (params) => {
        try {
            const response = await axios.get(`${API_URL}/category`, { params });
            return response.data;
        } catch (error) {
            console.error('获取分类列表失败:', error);
            throw error;
        }
    },

    /**
     * 新增分类
     */
    createCategory: async (categoryData) => {
        try {
            const response = await axios.post(`${API_URL}/category`, categoryData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('创建分类失败:', error);
            throw error;
        }
    },

    /**
     * 更新分类
     */
    updateCategory: async (id, categoryData) => {
        try {
            const response = await axios.put(`${API_URL}/category/${id}`, categoryData);
            return response.data;
        } catch (error) {
            console.error('更新分类失败:', error);
            throw error;
        }
    },

    /**
     * 删除分类
     */
    deleteCategory: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/category/${id}`);
            return response.data;
        } catch (error) {
            console.error('删除分类失败:', error);
            throw error;
        }
    },

    /**
     * 获取分类详情
     */
    getCategoryDetail: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/category/${id}`);
            return response.data;
        } catch (error) {
            console.error('获取分类详情失败:', error);
            throw error;
        }
    },

    /**
     * 更新分类状态
     */
    updateCategoryStatus: async (id, isActive) => {
        try {
            const response = await axios.put(`${API_URL}/category/${id}/status`, { is_active: isActive });
            return response.data;
        } catch (error) {
            console.error('更新分类状态失败:', error);
            throw error;
        }
    },
    
     /**
     * 更新分类排序
     */
    reorderCategory: async (orderData) => {
        try {
            const response = await axios.put(`${API_URL}/category/reorder`, orderData);
            return response.data;
        } catch (error) {
            console.error('更新分类排序失败:', error);
            throw error;
        }
    },

     /**
     * 获取营地类型列表
     */
     getCampType: async () => {
        try {
            const response = await axios.get(`${API_URL}/camp-type`);
            return response.data;
        } catch (error) {
            console.error('获取营地类型列表失败:', error);
            throw error;
        }
    },
};

export default categoryAPI;